(function (angular) {
	'use strict';

	angular
		.module('forgotPasswordModule')
		.controller('ForgotPassword', [
			'urlFactory',
			'vcRecaptchaService',
			ForgotPasswordControllerFunction
		]);

	function ForgotPasswordControllerFunction(
		urlFactory,
		vcRecaptchaService
	) {	
		var forgotPassword = this;
		var widgetId;

		forgotPassword.initRecaptcha = function(){
			vcRecaptchaService.execute(widgetId);
		};

		forgotPassword.resetRecaptcha = function(){
			vcRecaptchaService.reload(widgetId);
			forgotPassword.formSubmitted = false;
		};

		forgotPassword.setWidgetId = function(id){
			widgetId = id;
		};

		forgotPassword.successfulRecaptcha = function() {
			forgotPassword.recaptchaResponse = vcRecaptchaService.getResponse(widgetId);
			urlFactory.submitFormById('forgotPasswordForm');
		};
	}
})(window.angular);